import { IUser } from '~/models';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

async function getSelectedOffice(officeId: string): Promise<IUser> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IUser>(`/auth/me`, {
    headers: { ...headers, 'x-office': officeId },
  });

  return response.data;
}

export const selectedOfficeApi = {
  getSelectedOffice,
};
